import React, {Component} from 'react';

export default class BannerLink extends Component {
    render() {
        return (
            <div className="d-flex justify-content-center banner-caption w-100">
                <a className="dl-app hvr-fade-j" href="" target="_blank" title="">
                    <img src="./../../assets/images/dl-ios.png" className="img-responsive " alt=""/>
                    <img src="./../../assets/images/dl-ios-hover.png"
                         className="img-responsive hover-dl hidden-xs" alt=""/>
                </a>
                <a className="dl-app hvr-fade-j" href="" target="_blank" title="">
                    <img src="./../../assets/images/dl-android.png" className="img-responsive " alt=""/>
                    <img src="./../../assets/images/dl-android-hover.png"
                         className="img-responsive hover-dl hidden-xs" alt=""/>
                </a>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/banner/Banner-link.js